import { Box, Menu, MenuItem, Button, styled } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Menu as MenuIcon } from "lucide-react";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [burgerEL, setBurgerEL] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const handleClickBurger = (event) => setBurgerEL(event.currentTarget);
  const handleCloseBurger = () => setBurgerEL(null);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const StyledLink = styled(Link)(({ theme }) => ({
    textDecoration: "none",
    fontSize: "1.1rem",
    fontStyle: "italic",
    fontWeight: "600",
    color: "#004D7B",
    transition: "color 0.3s",
    "&:hover": {
      color: "#002D4B",
    },
    "&:after": {
      content: '""',
      display: "block",
      width: "0",
      height: "2px",
      backgroundColor: theme.palette.primary.main,
      transition: "width 0.5s ease-in-out",
    },
    "&:hover:after": {
      width: "100%",
    },
  }));

  return (
    <Box
      component="nav"
      sx={{
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 1000,
        transition: "all 0.3s ease-in-out",
        backgroundColor: "white",
        boxShadow: scrolled ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none",
        backdropFilter: scrolled ? "blur(10px)" : "none",
      }}
    >
      <Box
        px={1}
        sx={{
          color: "text.primary",
          transition: "all 0.3s ease-in-out",
          width: { xs: "100%", md: "90%" },
          margin: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box sx={{ padding: "10px" }}>
  <Link to="#home" style={{ display: "inline-block" }} onClick={() => scrollToSection("home")}>
    <img
      width={80}
      height={80}
      src="/taal-logo.png"
      alt="Taal Travel and Visa"
      style={{ cursor: "pointer" }}
    />
  </Link>
</Box>


          <Box display={{ md: "flex", xs: "none" }} alignItems="center">
            <Box mr={2}>
              <StyledLink to="#home"onClick={() => scrollToSection("home")}>Home</StyledLink>
            </Box>
            <Box mr={2}>
              <StyledLink to="#about" onClick={() => scrollToSection("about")}>
                About
              </StyledLink>
            </Box>
            <Box mr={2}>
              <StyledLink
                to="#services"
                onClick={() => scrollToSection("services")}
              >
                Services
              </StyledLink>
            </Box>
            <Box mr={2}>
              <StyledLink
                to="#contact"
                onClick={() => scrollToSection("contact")}
              >
                Contact
              </StyledLink>
            </Box>
          </Box>

          {/* Mobile Menu */}
          <Box display={{ md: "none", xs: "block" }}>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClickBurger}
              aria-label="open navigation menu"
            >
              <MenuIcon size={24} />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={burgerEL}
              keepMounted
              open={Boolean(burgerEL)}
              onClose={handleCloseBurger}
              PaperProps={{
                sx: {
                  backgroundColor: "white",
                  color: "black",
                  borderRadius: "8px",
                  boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <MenuItem onClick={handleCloseBurger}>
                <StyledLink to="#home"
                onClick={() => scrollToSection("home")}
                >Home</StyledLink>
              </MenuItem>
              <MenuItem onClick={handleCloseBurger}>
                <StyledLink
                  to="#about"
                  onClick={() => scrollToSection("about")}
                >
                  About
                </StyledLink>
              </MenuItem>
              <MenuItem onClick={handleCloseBurger}>
                <StyledLink
                  to="#services"
                  onClick={() => scrollToSection("services")}
                >
                  Services
                </StyledLink>
              </MenuItem>
              <MenuItem onClick={handleCloseBurger}>
                <StyledLink
                  to="#contact"
                  onClick={() => scrollToSection("contact")}
                >
                  Contact
                </StyledLink>
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NavBar;
